export const API_TOOLS_URL: string = process.env.NX_API_TOOLS || '';
export const PICSART_API_BASE_URL = process.env.NX_PICSART_API || '';
export const AUTH_REDIRECT_URL: string = process.env.NX_AUTH_REDIRECT || '';
export const AUTH_CLIENT_ID = process.env.NX_AUTH_CLIENT_ID || '';
export const AUTH_POPUP_BASE = process.env.NX_AUTH_POPUP_BASE || '';
export const AUTH_ACCEPTED_ORIGIN = process.env.NX_AUTH_ACCEPTED_ORIGIN || '';

// Google Add Manager
export const GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_WEB =
  process.env.NX_GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_WEB;

export const GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB =
  process.env.NX_GOOGLE_AD_MANAGER_QT_LEADER_BOARD_WEB;

export const GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_MOBILE =
  process.env.NX_GOOGLE_AD_MANAGER_QT_RIGHT_RAIL_MOBILE;

export const GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE =
  process.env.NX_GOOGLE_AD_MANAGER_QT_LEADER_BOARD_MOBILE;
